import { Link } from 'react-router-dom';
import LazyImage from '../../LazyImage';

const SpecialCardv1 = ({
    special,
    menuSlug,
    menuSpecials,
    singleSpecialView,
    setSelectedSpecialId
}) => {
    return (
        menuSpecials ? (
            <div
                className='headless-specials-card headless-specials-card-theme-v1'
                style={{
                    backgroundImage: `url(${
                        special?.menuDisplayConfiguration?.image !=
                        '/images/default-special-card.jpg'
                            ? special?.menuDisplayConfiguration?.image
                            : 'https://range-headless.s3.amazonaws.com/specials-bg.jpg'
                    })`,
                }}
                onClick={() => {
                    if (!singleSpecialView) {
                        setSelectedSpecialId(special.id);
                    }
                }}
            >
                <div className='headless-specials-card-overlay'></div>
                <div className='headless-specials-card-info'>
                    <div className='headless-specials-title'>{special.name}</div>
                    {singleSpecialView && special?.menuDisplayConfiguration?.description && (
                        <div className='headless-specials-description'>{special.menuDisplayConfiguration.description}</div>
                    )}
                </div>
                {!singleSpecialView && (
                    <a role='button' className='headless-specials-button'>
                        Shop Now
                    </a>
                )}
            </div>
        ) : (
            <Link to={`/shop/${menuSlug}/special/${special.id}/`} reloadDocument>
                <LazyImage
                    classnames='headless-specials-card headless-specials-card-theme-v1'
                    styles={{
                        backgroundImage: `url(${
                            special.menuDisplayConfiguration.image !=
                            '/images/default-special-card.jpg'
                                ? special.menuDisplayConfiguration.image
                                : 'https://range-headless.s3.amazonaws.com/specials-bg.jpg'
                        })`,
                    }}
                >
                    <div className='headless-specials-card-overlay'></div>
                    <div className='headless-specials-title'>{special.name}</div>
                    <div className='headless-specials-button-wrapper'>
                        <button className='headless-specials-button'>
                            Shop Now
                        </button>
                    </div>
                </LazyImage>
            </Link>  
        )
    );
};
    
export default SpecialCardv1;
